module.exports = __webpack_public_path__ + "img/pass.515e9b6e.svg";